import { createContext } from 'react'

export const TourContext = createContext()
